<template>
    <div>
        <fa-icon :icon="getStatusIconClass(status)" :class="(mode || '') + ' icon'"></fa-icon>
    </div>
</template>

<script>
    import { getStatusColorClass, getStatusIconClass } from '../utility/StatusGenerator';

    export default {
        props: {
            status: String,
            mode: String
        },
        methods: {
            getStatusClass: getStatusColorClass,
            getStatusIconClass: getStatusIconClass,
        },
        data() {
            return {};
        }
    }
</script>

<style scoped lang="scss">
    div {
        width: 100%;
        height: 100%;

        position: relative;

        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60%;
            height: 60%;

            &.light {
                color: white;
            }

            &.dark {
                color: $black;
            }

            &.dark-gray {
                color: $dark-gray;
            }
        }
    }
</style>